
export class FormSectionOptions {
  isCollapsible: boolean;
  render: boolean;
}
